import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { makeStyles } from 'tss-react/mui';

import { payeesSelectors, payeesUtils } from 'app-components/flux/payees';

const useStyles = makeStyles()(() => ({
  capitalize: {
    textTransform: 'capitalize',
    backgroundColor: 'unset',
  },
}));

const PayeeAutocomplete = React.memo((props) => {
  const { textFieldProps, inputValue, ...autoCompleteProps } = props;
  const { classes } = useStyles();

  const payees = useSelector(payeesSelectors.getPayeesNamesSorted).toArray();
  return (
    <Autocomplete
      id='payee'
      sharedcomponentid={'PAYEE_AUTOCOMPLETE'}
      options={payees}
      getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
      autoComplete
      autoHighlight
      clearOnEscape
      freeSolo
      openOnFocus
      disableClearable
      forcePopupIcon
      popupIcon={<ArrowDropDownRoundedIcon />}
      renderInput={(params) => (
        <TextField
          {...params}
          label='Payee'
          // margin="normal"
          placeholder='Search all Payees'
          variant='filled'
          {...textFieldProps}
        />
      )}
      {...autoCompleteProps}
      // inputValue={inputValue.toLowerCase()} // we don't want to loose cursor position when changing first letter of the word
      inputValue={inputValue || ''}
      onInputChange={(event, value, reason) =>
        autoCompleteProps.onInputChange?.(event, payeesUtils.capitalizePayee(value), reason)
      }
      classes={{
        input: classes.capitalize,
        ...autoCompleteProps.classes,
      }}
    />
  );
});

PayeeAutocomplete.displayName = 'PayeeAutocomplete';

PayeeAutocomplete.propTypes = {
  textFieldProps: PropTypes.object,
  inputValue: PropTypes.string,
};

export default PayeeAutocomplete;
